import { Box, CircularProgress } from "@mui/material";

/**
 * Inline, non-blocking loading indicator.
 * Use this instead of LoadingDialog for page-level and section-level loading states.
 *
 * The spinner is centred vertically within the available space so it
 * works both as a full-page loader and inside a smaller container.
 */
const LoadingSpinner = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "40vh",
      }}
      aria-label="Loading"
      role="status"
    >
      <CircularProgress color="primary" />
    </Box>
  );
};

export default LoadingSpinner;
